import { useOrganizationList } from '@clerk/clerk-react'
import type { ClerkOrganizationMembership } from '@saaga/shared/interfaces/auth.interface'
import { useAppDispatch } from '@saaga/shared/store/store'
import { useCallback } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { dispatchOrganizationReset } from '@/hooks/organization-reset.helper'

import { getOrgSwitchTargetPath } from './org-switch-navigation.helper'

export const useOrganizationSelect = (
  membershipList: ClerkOrganizationMembership[]
): ((orgId: string) => void) => {
  const { setActive } = useOrganizationList()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { orgSlug } = useParams<{ orgSlug: string }>()

  return useCallback(
    (orgId: string) => {
      const target = membershipList.find((m) => m.organizationId === orgId)
      if (!target?.organizationSlug || !setActive) return

      setActive({ organization: orgId }).then(() => {
        dispatchOrganizationReset(dispatch, orgId)
        navigate(getOrgSwitchTargetPath(location.pathname, orgSlug, target.organizationSlug))
      })
    },
    [setActive, membershipList, navigate, location.pathname, orgSlug, dispatch]
  )
}
